export const STORE_BOTS = 'STORE_BOTS'
export const SET_ACTIVE_BOT = 'SET_ACTIVE_BOT'

export const storeBots = (bots) => {
    return { type: 'STORE_BOTS', payload: bots }
}
